import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './Theme/theme';
import './styles/common.scss';
import { BrowserRouter, Routes, Route } from 'react-router';
import reportWebVitals from './reportWebVitals';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
// Screens
import Splash from './screens/Splash/Splash';
import Home from './screens/Home/Home';
import Search from './screens/Search/Search';
import Favorites from './screens/Favorites/Favorites';
import Profile from './screens/Profile/Profile';
import Cart from './screens/Cart/Cart';
import ProductDetails from './screens/ProductDetails/ProductDetails';
import Checkout from './screens/Checkout/Checkout';
import AddAddress from './screens/Checkout/AddAddress';
import ShippingSelection from './screens/Checkout/ShippingSelection';
import ReviewSummary from './screens/Checkout/ReviewSummary';
import PaymentMethods from './screens/Checkout/PaymentMethods';
import PaymentFailure from './screens/Checkout/PaymentFailure';
import PaymentSuccess from './screens/Checkout/PaymentSuccess';
import EReceipt from './screens/Checkout/EReceipt';
import ContactUs from './screens/Support/ContactUs';
import Offers from './screens/Offers/Offers';
import Categories from './screens/Categories/Categories';
import Logout from './screens/Logout/Logout';
import AdminLogin from './screens/AdminLogin/AdminLogin';
import AdminDashboard from './screens/AdminDashboard/AdminDashboard';
import CategoriesPage from './screens/AdminPages/CategoriesPage';
import ProductsPage from './screens/AdminPages/ProductsPage';
import VariantsPage from './screens/AdminPages/VariantsPage';
import InventoryPage from './screens/AdminPages/InventoryPage';
import OrdersPage from './screens/AdminPages/OrdersPage';
import UsersPage from './screens/AdminPages/UsersPage';
import CouponsPage from './screens/AdminPages/CouponsPage';
import BannersPage from './screens/AdminPages/BannersPage';
import DeliverySlotsPage from './screens/AdminPages/DeliverySlotsPage';
import NotificationsPage from './screens/AdminPages/NotificationsPage';
import ReportsPage from './screens/AdminPages/ReportsPage';
import SettingsPage from './screens/AdminPages/SettingsPage';
import SignIn from './screens/Auth/SignIn';
import SignUp from './screens/Auth/SignUp';
// Layouts
import AdminLayout from './components/AdminLayout/AdminLayout';
import ProtectedAdminRoute from './components/ProtectedAdminRoute/ProtectedAdminRoute';
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
// Context

import { AppProvider } from './contexts/AppContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path='/splash' element={<Splash />} />
            <Route path='/myadmin' element={<AdminLogin />} />
            <Route path='/signin' element={<SignIn />} />
            <Route path='/signup' element={<SignUp />} />
            <Route path='/myadmin' element={<ProtectedAdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route path='dashboard' element={<AdminDashboard />} />
                <Route path='categories' element={<CategoriesPage />} />
                <Route path='products' element={<ProductsPage />} />
                <Route path='variants' element={<VariantsPage />} />
                <Route path='inventory' element={<InventoryPage />} />
                <Route path='orders' element={<OrdersPage />} />
                <Route path='users' element={<UsersPage />} />
                <Route path='coupons' element={<CouponsPage />} />
                <Route path='banners' element={<BannersPage />} />
                <Route path='delivery-slots' element={<DeliverySlotsPage />} />
                <Route path='notifications' element={<NotificationsPage />} />
                <Route path='reports' element={<ReportsPage />} />
                <Route path='settings' element={<SettingsPage />} />
              </Route>
            </Route>
            <Route element={<Layout />}>
              <Route path='/' element={<Home />} />
              <Route path='/search' element={<Search />} />
              <Route path='/favorites' element={<Favorites />} />
              <Route path='/profile' element={<Profile />} />
              <Route path='/cart' element={<Cart />} />
              <Route path='/support' element={<ContactUs />} />
              <Route path='/offers' element={<Offers />} />
              <Route path='/categories' element={<Categories />} />
              <Route path='/logout' element={<Logout />} />
              <Route
                path='/products/:productId/:slug?'
                element={<ProductDetails />}
              />
              <Route
                path='/productdetails/:productId'
                element={<ProductDetails />}
              />
              <Route path='/checkout' element={<Checkout />} />
              <Route path='/checkout/address/new' element={<AddAddress />} />
              <Route path='/checkout/shipping' element={<ShippingSelection />} />
              <Route path='/checkout/review' element={<ReviewSummary />} />
              <Route path='/checkout/payment-methods' element={<PaymentMethods />} />
              <Route path='/checkout/payment-failure' element={<PaymentFailure />} />
              <Route path='/checkout/payment-success' element={<PaymentSuccess />} />
              <Route path='/checkout/e-receipt' element={<EReceipt />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
